/**
 * 简化能耗估算（设计文档 3.7 / metrics/energy-model.ts，PRD 假设 5）。
 *
 * E = Σ运行段 [ k1·d·(m轿厢+m载荷) + k2·启停次数 ] − k3·下行轻载回馈
 * 估算值，非精确电气仿真；界面与文档须标注。
 */

export const DEFAULT_PAX_MASS_KG = 70;

// 量级常数（J 单位），可配置；当前为合理估算默认值
const K1 = 25; // J / (m·kg)
const K2 = 50_000; // J / stop
const REGEN_FRACTION = 0.15; // 下行轻载回馈比例

export function segmentEnergyJ(
  distanceM: number,
  load: number,
  capacity: number,
  goingDown: boolean,
  carMassKg: number,
  paxMassKg = DEFAULT_PAX_MASS_KG,
): number {
  if (distanceM <= 0) return 0;
  let e = K1 * distanceM * (carMassKg + load * paxMassKg) + K2;
  if (goingDown && load < capacity * 0.3) e *= 1 - REGEN_FRACTION;
  return e;
}
